export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'radio',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'radio',
  },
  {
    title: that.$l('INDEX.form_contractNo') || '合同号',
    field: 'contractNo',
    width: 140,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_bookingType') || '订舱类型',
    field: 'v_bookingType',
    width: 100,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_vessel') || '船名',
    field: 'vessel',
    width: 100,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_voyage') || '航次',
    field: 'voyage',
    width: 100,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_dispatchPort') || '发运港口',
    field: 'v_dispatchPort',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_destinationPort') || '目的港口',
    field: 'v_destinationPort',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_label_shipmentType') || '出运方式',
    field: 'v_shipmentType',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_quotedMethod') || '报价方式',
    field: 'v_quotedMethod',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.form_label_plannedETD') || '计划发运日期',
    field: 'plannedETD',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_bookingDate') || '订舱日期',
    field: 'bookingDate',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },

  {
    title: that.$l('INDEX.form_deliveryDate') || '产装日期',
    field: 'deliveryDate',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_eta') || '到港日期',
    field: 'eta',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_ActualETD') || '实际发运日期',
    field: 'actualETD',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_docCutOffDate') || '截单日期',
    field: 'docCutOffDate',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_closingDate') || '开船日期',
    field: 'closingDate',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_contractNo') || '合同号',
    field: 'contractNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_custName') || '客户',
    field: 'custName',
    minWidth: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string'
  },

  {
    title: that.$l('INDEX.form_label_orderScmCode') || '名义工厂',
    field: 'orderScmName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.form_bookingScm') || '订舱货代',
    field: 'bookingScmName',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_transitScm') || '运输公司',
    field: 'transitScmName',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_shipper') || '发货人',
    field: 'shipperCustomerName',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_consignee') || '收货人',
    field: 'consigneeCustomerName',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_notifier') || '通知人',
    field: 'notifierCustomerName',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_totalGoodsQty') || '产品总数量',
    field: 'totalGoodsQty',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_totalBoxQty') || '总箱数',
    field: 'totalBoxQty',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_totalGrossWeight') || '总毛重',
    field: 'totalGrossWeight',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_totalNetWeight') || '总净重',
    field: 'totalNetWeight',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_totalBoxVolume') || '总体积',
    field: 'totalBoxVolume',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_totalBookingVolume') || '订舱总体积',
    field: 'totalBookingVolume',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  // {
  //   title: '总箱数',
  //   field: 'orderBatchNo',
  //   minWidth: 70,
  //   headerAlign: 'center',
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: '总毛重(KG)',
  //   field: 'orderBatchNo',
  //   minWidth: 70,
  //   headerAlign: 'center',
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: '总净重(kg)',
  //   field: 'orderBatchNo',
  //   minWidth: 70,
  //   headerAlign: 'center',
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: '总体积(m³)',
  //   field: 'orderBatchNo',
  //   minWidth: 70,
  //   headerAlign: 'center',
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: '订舱总体积(m³)',
  //   field: 'orderBatchNo',
  //   minWidth: 70,
  //   headerAlign: 'center',
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },

  {
    title: that.$l('INDEX.form_Batch Price Amount') || '工厂金额',
    field: 'v_totalPriceAmount',
    minWidth: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_shipmentSalePrice') || 'ABS金额',
    field: 'v_totalSalePriceAmount',
    minWidth: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
